import { useState } from 'react';

export default function WhatsAppFAB() {
  const [showTooltip, setShowTooltip] = useState(false);
  const phoneNumber = '15713652634';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=Hi%20Rafael%20M%26C!%20I'd%20like%20to%20discuss%20a%20project.`;

  return (
    <div className="fixed bottom-24 right-6 z-50 flex flex-col items-end gap-2">
      {showTooltip && (
        <div className="bg-foreground-900 text-background-50 text-xs md:text-sm px-4 py-2 rounded-lg shadow-lg whitespace-nowrap animate-fade-in-up">
          Chat with us on WhatsApp!
          <div className="absolute bottom-[-6px] right-5 w-3 h-3 bg-foreground-900 rotate-45"></div>
        </div>
      )}

      <a
        href={whatsappUrl}
        target="_blank"
        rel="nofollow noopener noreferrer"
        className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-background-50 shadow-lg hover:scale-110 hover:shadow-xl transition-all duration-300 cursor-pointer group"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="Chat on WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20 duration-1000"></span>
        <i className="ri-whatsapp-fill text-2xl md:text-3xl relative z-10"></i>
      </a>
    </div>
  );
}